(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesTypesDetailController', TabDevicesTypesDetailController);

    TabDevicesTypesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabDevicesTypes', 'TabDevices'];

    function TabDevicesTypesDetailController($scope, $rootScope, $stateParams, entity, TabDevicesTypes, TabDevices) {
        var vm = this;
        vm.tabDevicesTypes = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabDevicesTypesUpdate', function(event, result) {
            vm.tabDevicesTypes = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
